{
  "axios-context-provider.setting-up-environnement": {
    "translation": "Setting up your workspace"
  },
  "ensure-user.error-loading-user-infos": {
    "translation": "An error occurred while loading your account information"
  },
  "ensure-user.loading-user-infos": {
    "translation": "Loading account information"
  },
  "moby.error.generic": {
    "translation": "An error occurred. Mobsuccess has been alerted and is working to resolve the issue."
  },
  "monitoring.table.agent": {
    "translation": "Agent"
  },
  "monitoring.table.columns.changes": {
    "translation": "Changes"
  },
  "monitoring.table.columns.date": {
    "translation": "Date"
  },
  "monitoring.table.columns.entity-type": {
    "translation": "Entity Type"
  },
  "monitoring.table.columns.entity-uuid": {
    "translation": "Entity UUID"
  },
  "monitoring.table.columns.operation": {
    "translation": "Operation"
  },
  "monitoring.table.columns.user": {
    "translation": "User"
  },
  "monitoring.table.filter.all": {
    "translation": "All"
  },
  "monitoring.table.filter.all.tooltip": {
    "translation": "Show all entries, including updates with no actual changes"
  },
  "monitoring.table.filter.changes-only": {
    "translation": "Changes"
  },
  "monitoring.table.filter.changes-only.tooltip": {
    "translation": "Hide updates with no actual changes"
  },
  "monitoring.table.loading": {
    "translation": "Loading monitoring data..."
  },
  "monitoring.table.not-available": {
    "translation": "N/A"
  },
  "monitoring.table.system-user": {
    "translation": "System"
  },
  "mutation-error.toast.generic": {
    "translation": "The server rejected the request. Please check your input and try again."
  },
  "mutation-error.toast.title": {
    "translation": "Action failed"
  },
  "navigation-blocker.cancel": {
    "translation": "Cancel"
  },
  "navigation-blocker.form.description": {
    "translation": "Some fields in this form have been modified. If you leave this page, you will lose unsaved changes."
  },
  "navigation-blocker.form.title": {
    "translation": "Are you sure you want to leave this page?"
  },
  "navigation-blocker.proceed": {
    "translation": "Proceed"
  },
  "pending-page.loading-user-infos": {
    "translation": "Loading account information"
  },
  "src.features.use-service-pages.backoffice-client": {
    "translation": "Manage clients"
  },
  "src.features.use-service-pages.backoffice-kits": {
    "translation": "Manage kits"
  },
  "src.features.use-service-pages.backoffice-orders": {
    "translation": "Manage orders"
  },
  "src.features.use-service-pages.backoffice-statistics": {
    "translation": "Usage Statistics"
  },
  "src.features.use-service-pages.bo-dashboard-clients": {
    "translation": "Clients & access"
  },
  "src.features.use-service-pages.campaigns": {
    "translation": "Campaigns"
  },
  "src.features.use-service-pages.dashboard-manager": {
    "translation": "Dashboard manager"
  },
  "src.features.use-service-pages.detailed-reporting": {
    "translation": "Detailed reports"
  },
  "src.features.use-service-pages.docs": {
    "translation": "User docs"
  },
  "src.features.use-service-pages.faq": {
    "translation": "FAQ"
  },
  "src.features.use-service-pages.kits": {
    "translation": "Subscribe to kits"
  },
  "src.features.use-service-pages.my-subscribed-kits": {
    "translation": "My subscribed kits"
  },
  "src.features.use-service-pages.overview": {
    "translation": "Overview"
  },
  "src.features.use-service-pages.playground": {
    "translation": "Playground"
  },
  "src.public.auth.sign-out-error.description": {
    "translation": "Could not log out of the session"
  },
  "src.public.auth.sign-out-error.title": {
    "translation": "An error occurred"
  },
  "src.public.color.channel": {
    "placeholders": {
      "channel": ["channel"],
      "value": ["value"],
      "min": ["min"],
      "max": ["max"]
    },
    "translation": "The color value of {channel} must be between {min} and {max}"
  },
  "src.public.color.format": {
    "placeholders": {
      "format": ["format"]
    },
    "translation": "The color value must be in {format} format"
  },
  "src.public.custom-themes.error-description": {
    "translation": "Please try again later"
  },
  "src.public.custom-themes.error-title": {
    "translation": "An error occurred"
  },
  "src.public.customly.components.preview-container.retry": {
    "translation": "Restart playground"
  },
  "src.public.i18n.mt-edit.badge.label": {
    "translation": "Translations"
  },
  "src.public.i18n.mt-edit.badge.title": {
    "placeholders": {
      "shortcut": ["shortcutLabel"]
    },
    "translation": "Mobtranslate edit mode — click an underlined text to edit it (Alt+click on buttons, menus, and fields). {shortcut}: show/hide overlay (mt-edit=0 to quit)."
  },
  "src.public.i18n.mt-edit.banner.editing": {
    "placeholders": {
      "locale": ["localeLabel(opts.locale)"]
    },
    "translation": "You are editing: {locale}"
  },
  "src.public.i18n.mt-edit.banner.source": {
    "placeholders": {
      "locale": ["localeLabel(opts.locale)"]
    },
    "translation": "SOURCE — {locale}: modify the original text, translations will revert to 'to review'"
  },
  "src.public.i18n.mt-edit.close": {
    "translation": "Close"
  },
  "src.public.i18n.mt-edit.help.alt-click": {
    "translation": "Edit a button, menu, link, or field"
  },
  "src.public.i18n.mt-edit.help.alt-hold": {
    "translation": "Freeze elements on hover (tooltips, menus)"
  },
  "src.public.i18n.mt-edit.help.click": {
    "translation": "Edit an underlined text"
  },
  "src.public.i18n.mt-edit.help.escape": {
    "translation": "Close panel"
  },
  "src.public.i18n.mt-edit.help.kbd-click": {
    "translation": "Click"
  },
  "src.public.i18n.mt-edit.help.title": {
    "translation": "Edit mode shortcuts"
  },
  "src.public.i18n.mt-edit.help.toggle": {
    "translation": "Show/hide underlining"
  },
  "src.public.i18n.mt-edit.open-in-mobtranslate": {
    "translation": "Open in Mobtranslate"
  },
  "src.public.i18n.mt-edit.quit": {
    "translation": "Quit edit mode"
  },
  "src.public.i18n.mt-edit.save": {
    "translation": "Save"
  },
  "src.public.i18n.mt-edit.sign-in": {
    "translation": "Sign in to Mobtranslate ↗"
  },
  "src.public.i18n.mt-edit.status.auth-error": {
    "translation": "Mobtranslate session missing — sign in then try again:"
  },
  "src.public.i18n.mt-edit.status.error": {
    "translation": "Failed (Mobtranslate session missing or access blocked) — use the link below."
  },
  "src.public.i18n.mt-edit.status.saved": {
    "translation": "Saved in Mobtranslate."
  },
  "src.public.i18n.mt-edit.status.saved-source": {
    "translation": "Source corrected (translations reverted to 'to review')."
  },
  "src.public.i18n.mt-edit.status.saving": {
    "translation": "Saving..."
  },
  "src.public.i18n.mt-edit.status.suggest-error": {
    "translation": "AI suggestion failed."
  },
  "src.public.i18n.mt-edit.status.suggested": {
    "translation": "Suggestion inserted — verify then save."
  },
  "src.public.i18n.mt-edit.status.suggesting": {
    "translation": "AI suggesting..."
  },
  "src.public.i18n.mt-edit.suggest": {
    "translation": "Suggest"
  },
  "src.public.react-ui.account-dropdown.search-placeholder": {
    "translation": "Search..."
  },
  "src.public.react-ui.advertiser-picker.account-info": {
    "placeholders": {
      "accountId": ["accountId"],
      "clientId": ["clientId"]
    },
    "translation": "Advertiser {accountId} · Agency {clientId}"
  },
  "src.public.react-ui.advertiser-picker.add-to-favorites": {
    "translation": "Add to favorites"
  },
  "src.public.react-ui.advertiser-picker.close-hint": {
    "translation": "to close"
  },
  "src.public.react-ui.advertiser-picker.favorites-filter": {
    "translation": "Favorites"
  },
  "src.public.react-ui.advertiser-picker.favorites-section": {
    "translation": "Favorites"
  },
  "src.public.react-ui.advertiser-picker.navigate-hint": {
    "translation": "to navigate"
  },
  "src.public.react-ui.advertiser-picker.no-results": {
    "translation": "No results found."
  },
  "src.public.react-ui.advertiser-picker.no-selection": {
    "translation": "No advertiser selected"
  },
  "src.public.react-ui.advertiser-picker.placeholder": {
    "translation": "Search..."
  },
  "src.public.react-ui.advertiser-picker.remove-from-favorites": {
    "translation": "Remove from favorites"
  },
  "src.public.react-ui.advertiser-picker.select-hint": {
    "translation": "to select"
  },
  "src.public.react-ui.advertiser-picker.toggle-hint": {
    "translation": "to toggle"
  },
  "src.public.react-ui.advertiser-picker.toggle-tooltip": {
    "placeholders": {
      "shortcut": ["shortcut"]
    },
    "translation": "Use {shortcut} to toggle"
  },
  "src.public.react-ui.audio-player.error": {
    "translation": "Audio could not be loaded"
  },
  "src.public.react-ui.audio-player.loading": {
    "translation": "Audio is loading"
  },
  "src.public.react-ui.audio-player.pause": {
    "translation": "Pause"
  },
  "src.public.react-ui.audio-player.play": {
    "translation": "Play audio"
  },
  "src.public.react-ui.autocomplete.next-page": {
    "translation": "Load next page"
  },
  "src.public.react-ui.calendar.month": {
    "translation": "Month"
  },
  "src.public.react-ui.calendar.next-month": {
    "translation": "Next month"
  },
  "src.public.react-ui.calendar.others": {
    "translation": "others"
  },
  "src.public.react-ui.calendar.previous-month": {
    "translation": "Previous month"
  },
  "src.public.react-ui.calendar.today": {
    "translation": "Today"
  },
  "src.public.react-ui.calendar.toggle-all-items": {
    "translation": "View all items"
  },
  "src.public.react-ui.calendar.two-months": {
    "translation": "2 months"
  },
  "src.public.react-ui.calendar.week-letter": {
    "translation": "W"
  },
  "src.public.react-ui.calendar.year": {
    "translation": "Year"
  },
  "src.public.react-ui.chat.empty-subtitle": {
    "translation": "No messages match your filters"
  },
  "src.public.react-ui.chat.empty-title": {
    "translation": "No messages"
  },
  "src.public.react-ui.chat.labels.available-tags": {
    "translation": "Available tags"
  },
  "src.public.react-ui.chat.labels.back-to-conversation": {
    "translation": "Back to conversation"
  },
  "src.public.react-ui.chat.labels.favorite-button": {
    "translation": "Favorites"
  },
  "src.public.react-ui.chat.labels.favorite-count": {
    "placeholders": {
      "count": ["count"]
    },
    "translation": "{count, plural, one {# favorite} other {# favorites}}"
  },
  "src.public.react-ui.chat.labels.selected-tags": {
    "translation": "Selected tags"
  },
  "src.public.react-ui.chat.loading": {
    "translation": "Loading..."
  },
  "src.public.react-ui.chat.placeholders.search": {
    "translation": "Search messages..."
  },
  "src.public.react-ui.chat.send-button": {
    "translation": "Send"
  },
  "src.public.react-ui.command-menu.close-hint": {
    "translation": "to close"
  },
  "src.public.react-ui.command-menu.empty": {
    "translation": "No results found"
  },
  "src.public.react-ui.command-menu.navigate-hint": {
    "translation": "to navigate"
  },
  "src.public.react-ui.command-menu.placeholder": {
    "translation": "Search..."
  },
  "src.public.react-ui.command-menu.select-hint": {
    "translation": "to select"
  },
  "src.public.react-ui.command-menu.toggle-hint": {
    "translation": "to open/close"
  },
  "src.public.react-ui.data-editor.csv.apply": {
    "translation": "Apply"
  },
  "src.public.react-ui.data-editor.csv.format": {
    "translation": "Format"
  },
  "src.public.react-ui.data-editor.csv.revert": {
    "translation": "Reset"
  },
  "src.public.react-ui.data-editor.csv.unsaved-changes": {
    "translation": "Unsaved changes"
  },
  "src.public.react-ui.data-editor.csv.up-to-date": {
    "translation": "No changes"
  },
  "src.public.react-ui.data-editor.records": {
    "placeholders": {
      "count": ["count"]
    },
    "translation": "{count, plural, one {# record} other {# records}}"
  },
  "src.public.react-ui.data-editor.upload.error": {
    "translation": "The file could not be loaded"
  },
  "src.public.react-ui.data-editor.views.csv": {
    "translation": "CSV View"
  },
  "src.public.react-ui.data-editor.views.table": {
    "translation": "Table View"
  },
  "src.public.react-ui.date-range-picker.from": {
    "translation": "From"
  },
  "src.public.react-ui.date-range-picker.last-days": {
    "placeholders": {
      "days": ["14", "3", "30", "7", "90"]
    },
    "translation": "Last {days} days"
  },
  "src.public.react-ui.date-range-picker.last-month": {
    "translation": "Last month"
  },
  "src.public.react-ui.date-range-picker.last-quarter": {
    "translation": "Last quarter"
  },
  "src.public.react-ui.date-range-picker.last-week": {
    "translation": "Last week"
  },
  "src.public.react-ui.date-range-picker.last-year": {
    "translation": "Last year"
  },
  "src.public.react-ui.date-range-picker.range-placeholder": {
    "translation": "Filter by date"
  },
  "src.public.react-ui.date-range-picker.reset": {
    "translation": "Reset"
  },
  "src.public.react-ui.date-range-picker.this-month": {
    "translation": "This month"
  },
  "src.public.react-ui.date-range-picker.this-quarter": {
    "translation": "This quarter"
  },
  "src.public.react-ui.date-range-picker.this-week": {
    "translation": "This week"
  },
  "src.public.react-ui.date-range-picker.this-year": {
    "translation": "This year"
  },
  "src.public.react-ui.date-range-picker.to": {
    "translation": "to"
  },
  "src.public.react-ui.date-range-picker.today": {
    "translation": "Today"
  },
  "src.public.react-ui.date-range-picker.yesterday": {
    "translation": "Yesterday"
  },
  "src.public.react-ui.date-time-picker.ok": {
    "translation": "OK"
  },
  "src.public.react-ui.error-page.contact-support": {
    "translation": "Please do not hesitate to contact support if the problem persists."
  },
  "src.public.react-ui.error-page.description": {
    "translation": "An error occurred, please try again later."
  },
  "src.public.react-ui.error-page.go-back": {
    "translation": "Back"
  },
  "src.public.react-ui.error-page.go-home": {
    "translation": "Go to homepage"
  },
  "src.public.react-ui.error-page.title": {
    "translation": "Internal error"
  },
  "src.public.react-ui.field.char-count": {
    "placeholders": {
      "count": ["count"],
      "limit": ["limit"]
    },
    "translation": "{count}/{limit} characters"
  },
  "src.public.react-ui.field.optional": {
    "translation": "Optional"
  },
  "src.public.react-ui.file-upload.rejected.reason": {
    "placeholders": {
      "reasons": ["reasons.join(\", \")"]
    },
    "translation": "Rejected for the following reasons: {reasons}"
  },
  "src.public.react-ui.file-upload.rejected.title": {
    "placeholders": {
      "name": ["name"]
    },
    "translation": "File \"{name}\" has been rejected"
  },
  "src.public.react-ui.filters.search-placeholder": {
    "translation": "Search"
  },
  "src.public.react-ui.general.confirm-reset.cancel": {
    "translation": "Cancel"
  },
  "src.public.react-ui.general.confirm-reset.confirm": {
    "translation": "Reset"
  },
  "src.public.react-ui.general.confirm-reset.description": {
    "translation": "Are you sure you want to reset? All data will be lost."
  },
  "src.public.react-ui.general.confirm-reset.title": {
    "translation": "Reset all changes?"
  },
  "src.public.react-ui.general.confirm-submit.cancel": {
    "translation": "Cancel"
  },
  "src.public.react-ui.general.confirm-submit.confirm": {
    "translation": "Confirm"
  },
  "src.public.react-ui.general.confirm-submit.title": {
    "translation": "Do you want to continue?"
  },
  "src.public.react-ui.general.reset": {
    "translation": "Reset"
  },
  "src.public.react-ui.general.save": {
    "translation": "Save"
  },
  "src.public.react-ui.general.save-and-close": {
    "translation": "Save and close"
  },
  "src.public.react-ui.header-account-picker.search-placeholder": {
    "translation": "Search..."
  },
  "src.public.react-ui.header-account-picker.select-account": {
    "translation": "Select an account"
  },
  "src.public.react-ui.moby.ask-a-question": {
    "translation": "Ask a question here"
  },
  "src.public.react-ui.moby.cancel": {
    "translation": "Cancel"
  },
  "src.public.react-ui.moby.copied-message": {
    "translation": "Copied"
  },
  "src.public.react-ui.moby.copy-message": {
    "translation": "Copy message"
  },
  "src.public.react-ui.moby.description": {
    "translation": "The AI assistant from mobsuccess"
  },
  "src.public.react-ui.moby.download-file": {
    "translation": "Download file"
  },
  "src.public.react-ui.moby.download-file-error": {
    "translation": "Download failed"
  },
  "src.public.react-ui.moby.downloading-file": {
    "translation": "Downloading..."
  },
  "src.public.react-ui.moby.happy-with-this-conv": {
    "translation": "Happy with this exchange?"
  },
  "src.public.react-ui.moby.open-chat": {
    "translation": "Open Moby chat"
  },
  "src.public.react-ui.moby.reset": {
    "translation": "Reset"
  },
  "src.public.react-ui.moby.reset-request": {
    "translation": "Reset request"
  },
  "src.public.react-ui.moby.reset-request-description": {
    "translation": "Do you really want to clear and reset your request?"
  },
  "src.public.react-ui.moby.send": {
    "translation": "Send"
  },
  "src.public.react-ui.moby.title": {
    "translation": "Moby"
  },
  "src.public.react-ui.not-allowed.description": {
    "translation": "You are not authorized to access this page."
  },
  "src.public.react-ui.not-allowed.go-back": {
    "translation": "Back"
  },
  "src.public.react-ui.not-allowed.go-home": {
    "translation": "Go to homepage"
  },
  "src.public.react-ui.not-allowed.request-id": {
    "placeholders": {
      "id": ["id"]
    },
    "translation": "Request ID: {id}"
  },
  "src.public.react-ui.not-allowed.title": {
    "translation": "Access denied"
  },
  "src.public.react-ui.not-found-error-page.clear-filters": {
    "translation": "Reset filters"
  },
  "src.public.react-ui.not-found-error-page.description": {
    "translation": "The filters you applied do not match any results."
  },
  "src.public.react-ui.not-found-error-page.title": {
    "translation": "No results"
  },
  "src.public.react-ui.pagination.first-page": {
    "translation": "First page"
  },
  "src.public.react-ui.pagination.last-page": {
    "translation": "Last page"
  },
  "src.public.react-ui.pagination.next-page": {
    "translation": "Next page"
  },
  "src.public.react-ui.pagination.page-size-label": {
    "translation": "Show"
  },
  "src.public.react-ui.pagination.page-size-options": {
    "placeholders": {
      "size": ["size"]
    },
    "translation": "{size} rows"
  },
  "src.public.react-ui.pagination.previous-page": {
    "translation": "Previous page"
  },
  "src.public.react-ui.select.copy": {
    "translation": "Copy"
  },
  "src.public.react-ui.select.copy-success": {
    "translation": "Selection copied to clipboard"
  },
  "src.public.react-ui.select.copy-tooltip": {
    "translation": "Copy selection to clipboard"
  },
  "src.public.react-ui.select.paste": {
    "translation": "Paste from clipboard"
  },
  "src.public.react-ui.select.paste-error-description": {
    "translation": "Pasted items were not in the correct format. Make sure to use the format \"id_1;id_2\""
  },
  "src.public.react-ui.select.paste-error-title": {
    "translation": "Paste error"
  },
  "src.public.react-ui.select.paste-tooltip": {
    "translation": "Replace current selection with clipboard values"
  },
  "src.public.react-ui.select.remove-all": {
    "translation": "Clear all"
  },
  "src.public.react-ui.select.select-all": {
    "translation": "Select all"
  },
  "src.public.react-ui.sidebar.admin": {
    "translation": "Administration"
  },
  "src.public.react-ui.sidebar.edit-translations": {
    "translation": "Edit translations"
  },
  "src.public.react-ui.sidebar.language-selector-dialog.cancel": {
    "translation": "Cancel"
  },
  "src.public.react-ui.sidebar.language-selector-dialog.confirm": {
    "translation": "Confirm"
  },
  "src.public.react-ui.sidebar.language-selector-dialog.description": {
    "translation": "Change language"
  },
  "src.public.react-ui.sidebar.language-selector-dialog.error-description": {
    "translation": "This language is not supported"
  },
  "src.public.react-ui.sidebar.language-selector-dialog.error-title": {
    "translation": "Error loading language"
  },
  "src.public.react-ui.sidebar.language-selector-dialog.title": {
    "translation": "Select a language"
  },
  "src.public.react-ui.sidebar.logout": {
    "translation": "Log out"
  },
  "src.public.react-ui.sidebar.open-menu": {
    "translation": "Open menu"
  },
  "src.public.react-ui.table.arrange-columns": {
    "translation": "Edit column layout"
  },
  "src.public.react-ui.table.collapse-all-rows": {
    "translation": "Hide all details"
  },
  "src.public.react-ui.table.collapse-row": {
    "translation": "Hide details"
  },
  "src.public.react-ui.table.expand-all-rows": {
    "translation": "Show all details"
  },
  "src.public.react-ui.table.expand-row": {
    "translation": "Show details"
  },
  "utils.empty-account-infos": {
    "translation": "No account available"
  },
  "utils.loading-account-infos": {
    "translation": "Loading account information"
  },
  "validation.file.allowedTypes": {
    "placeholders": {
      "types": [
        "Array.isArray(types) ? types.join(\", \") : types",
        "types.join(\", \")"
      ]
    },
    "translation": "The file type must be one of: {types}"
  },
  "validation.file.audio.maximumDuration": {
    "placeholders": {
      "duration": ["duration"]
    },
    "translation": "The audio must have a maximum duration of {duration} seconds"
  },
  "validation.file.audio.minimumDuration": {
    "placeholders": {
      "duration": ["duration"]
    },
    "translation": "The audio must have a minimum duration of {duration} seconds"
  },
  "validation.file.image.aspectRatio": {
    "placeholders": {
      "ratios": ["ratios.map(([w, h]) => `${w}:${h}`).join(\", \")"]
    },
    "translation": "The image aspect ratio must be one of the following: {ratios}"
  },
  "validation.file.image.dimensions": {
    "placeholders": {
      "sizes": ["sizes.map(([w, h]) => `${w}x${h}`).join(\", \")"]
    },
    "translation": "The image dimensions must be one of the following: {sizes}"
  },
  "validation.file.maximumSize": {
    "placeholders": {
      "size": ["size"]
    },
    "translation": "The file size cannot exceed {size} bytes"
  },
  "validation.file.minimumSize": {
    "placeholders": {
      "size": ["size"]
    },
    "translation": "The file size cannot be less than {size} bytes"
  },
  "validation.file.mustBeAudio": {
    "translation": "The file must be an audio"
  },
  "validation.file.mustBeImage": {
    "translation": "The file must be an image"
  },
  "validation.file.mustBeVideo": {
    "translation": "The file must be a video"
  },
  "validation.file.namePattern": {
    "placeholders": {
      "pattern": ["pattern.source"]
    },
    "translation": "The file name must match the pattern: {pattern}"
  },
  "validation.file.video.aspectRatio": {
    "placeholders": {
      "ratios": ["ratios.map(([w, h]) => `${w}:${h}`).join(\", \")"]
    },
    "translation": "The video aspect ratio must be one of the following: {ratios}"
  },
  "validation.file.video.dimensions": {
    "placeholders": {
      "sizes": ["sizes.map(([w, h]) => `${w}x${h}`).join(\", \")"]
    },
    "translation": "The video dimensions must be one of the following: {sizes}"
  },
  "validation.file.video.maximumBitrate": {
    "placeholders": {
      "byterate": ["byterate"]
    },
    "translation": "The video must have a maximum bitrate of {byterate}"
  },
  "validation.file.video.maximumDuration": {
    "placeholders": {
      "duration": ["duration"]
    },
    "translation": "The video must have a maximum duration of {duration} seconds"
  },
  "validation.file.video.minimumBitrate": {
    "placeholders": {
      "byterate": ["byterate"]
    },
    "translation": "The video must have a minimum bitrate of {byterate}"
  },
  "validation.file.video.minimumDuration": {
    "placeholders": {
      "duration": ["duration"]
    },
    "translation": "The video must have a minimum duration of {duration} seconds"
  },
  "version-drift.notification.action-reload": {
    "translation": "Update"
  },
  "version-drift.notification.description": {
    "translation": "A new version is available. Please save your work before updating the page."
  },
  "version-drift.notification.title": {
    "translation": "Update available"
  }
}
